import { useState } from 'react';
import { SUPPORTED_LANGUAGES } from '../../utils/translationUtils';
import './TranslationInput.css';

const TranslationInput = ({ label, value, onChange, textarea, disabled }) => {
  const [activeLang, setActiveLang] = useState('en');

  return (
    <div className="translation-input">
      <span className="translation-label">{label}</span>
      <div className="translation-lang-tabs">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <button
            key={lang}
            type="button"
            className={activeLang === lang ? 'active' : ''}
            onClick={() => setActiveLang(lang)}
            >
            {lang.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="translation-field">
        {textarea ? (
          <textarea
            value={value[activeLang] || ''}
            onChange={e => onChange(activeLang, e.target.value)}
            disabled={disabled}
          />
        ) : (
          <input
            type="text"
            value={value[activeLang] || ''}
            onChange={e => onChange(activeLang, e.target.value)}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
};

export default TranslationInput;
